var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable react/no-unused-state */
import React from "react";
import { TrackJS } from "trackjs";
import ErrorMessage from "components/error_message";
import { isTracking as envIsTracking } from "helpers/analytics";
import HasError from "helpers/context/has_error";
// Number of times we should trust `props.children` to render something.
// Each time componentDidCatch, increment catchCount in state.
// After reaching this many errors, remove children from the tree and
// instead render a generic error.
var RETRY_THRESHOLD = 3;
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false,
            catchCount: 0,
            isTracking: envIsTracking(),
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error) {
        TrackJS.track(error);
        this.setState(function (_a) {
            var catchCount = _a.catchCount;
            return ({
                catchCount: catchCount + 1,
                error: error,
                hasError: true,
            });
        });
    };
    ErrorBoundary.prototype.render = function () {
        var children = this.props.children;
        var _a = this.state, hasError = _a.hasError, error = _a.error, catchCount = _a.catchCount;
        if (catchCount >= RETRY_THRESHOLD) {
            return (React.createElement("div", { className: "app" },
                React.createElement(ErrorMessage, null)));
        }
        return (React.createElement(HasError.Provider, { value: { hasError: hasError, error: error } }, children));
    };
    return ErrorBoundary;
}(React.Component));
export default ErrorBoundary;
